import React from 'react';

function accClass(pct) {
  if (pct === null || pct === undefined) return '';
  if (pct < 50) return 'qp-stat-acc-red';
  if (pct < 70) return 'qp-stat-acc-amber';
  return 'qp-stat-acc-green';
}

export default function QuestionStats({ stats }) {
  // Always render the 5 cards so labels and zeros show even before/without data.
  const safe = stats || {};
  const total_attempted = safe.total_attempted ?? 0;
  const total_correct = safe.total_correct ?? 0;
  const accuracy_pct = safe.accuracy_pct;
  const attempted_today = safe.attempted_today ?? 0;
  const streak = safe.streak ?? 0;

  return (
    <div className="qp-stats-row">
      <div className="qp-stat-card">
        <div className="qp-stat-value">{total_attempted ?? 0}</div>
        <div className="qp-stat-label">Attempted</div>
      </div>
      <div className="qp-stat-card">
        <div className="qp-stat-value">{total_correct ?? 0}</div>
        <div className="qp-stat-label">Correct</div>
      </div>
      <div className="qp-stat-card">
        <div className={`qp-stat-value ${accClass(accuracy_pct)}`}>
          {accuracy_pct != null ? `${accuracy_pct}%` : '—'}
        </div>
        <div className="qp-stat-label">Accuracy</div>
      </div>
      <div className="qp-stat-card">
        <div className="qp-stat-value">{attempted_today ?? 0}</div>
        <div className="qp-stat-label">Today</div>
      </div>
      <div className="qp-stat-card">
        <div className="qp-stat-value">{streak ?? 0}</div>
        <div className="qp-stat-label">Streak</div>
      </div>
    </div>
  );
}
